<template>
  <fragment>
    <t-dialog ref="firstAccessDialog" dense light :fullscreen="$forSize['phone-only']">
      <template v-slot:title>
        <span v-html="$config.strings['s018']" />
      </template>
      <template v-slot:text>
        <div class="dialog-content">
          <img :src="$config.images['loginModal']" alt="Orientações do primeiro acesso" />
          <t-button size="lg" @click="loginRedirect" :backgroundColor="$config.colors.secondary" :color="$config.colors.on.secondary" v-html="$config.strings['loginModal-btn']" />
        </div>
      </template>
    </t-dialog>
  </fragment>
</template>

<script>
import { TDialog, TButton } from '@/components/base'

export default {
  name: 'dialog-first-access',
  components: { TDialog, TButton },
  mounted () {
    this.$events.$on('OPEN-FIRST-ACCESS-DIALOG', () => {
      this.$refs.firstAccessDialog.open()
    })
  },
  beforeDestroy () {
    this.$events.$off('OPEN-FIRST-ACCESS-DIALOG')
  },
  methods: {
    loginRedirect () {
      location.href = this.$config.urls.login_url
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  padding: 15px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;

  > img {
    max-width: 95%;
  }

  > button {
    padding: 12.5px 20px;
  }

}
</style>
